import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isDisabled: false,
  filterOptions: [],
  showLangChange: true,
  activeOptionComp: null,
  scheduleDateAvail: false,
};

export const optionBoxSlice = createSlice({
  name: "optionBox",
  initialState,
  reducers: {
    setIsDisabled: (state, action) => {
      state.isDisabled = action.payload;
    },
    setFilterOptions: (state, action) => {
      state.filterOptions = action.payload;
    },
    setShowLangChange: (state, action) => {
      state.showLangChange = action.payload;
    },
    setActiveOptionComp: (state, action) => {
      state.activeOptionComp = action.payload;
    },
    setScheduleDateAvail: (state, action) => {
      state.scheduleDateAvail = action.payload;
    },
  },
});

export const selectIsDisabled = (state) => state.optionBox.isDisabled;
export const getFilterOptions = (state) => state.optionBox.filterOptions;
export const getShowLangChange = (state) => state.optionBox.showLangChange;
export const getActiveOptionComp = (state) => state.optionBox.activeOptionComp;
export const getScheduleDateAvail = (state) => state.optionBox.scheduleDateAvail;

export const { setIsDisabled, setFilterOptions, setShowLangChange, setActiveOptionComp, setScheduleDateAvail } = optionBoxSlice.actions;

export default optionBoxSlice.reducer;
